import { Action, Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { RootState } from '../redux/types';
import { MarketMap, StateProps, DispatchProps } from '../components/market-map/MarketMap';
import { toast } from '../redux/message/actions';
import { viewingBoundsDidChange, patchArea, createArea, deleteArea } from '../redux/market-map/actions';
import { setLastMapLocation } from '../redux/ui/actions';
import { Area } from '../redux/market-map/types';

export function mapStateToProps(state: RootState): StateProps {
  const loadedAreasById: Record<string, Area> = {};

  for (let i = 0; i < state.marketMap.loadedAreas.length; i++) {
    if (state.marketMap.loadedAreas[i].id !== undefined) {
      loadedAreasById[state.marketMap.loadedAreas[i].id!] = state.marketMap.loadedAreas[i];
    }
  }
  return {
    loadedAreaList: state.marketMap.loadedAreas,
    loadedAreasById: loadedAreasById,
    markets: state.markets.markets,
    allMarkets: state.markets.allMarkets,
    lastMapLocation: state.ui.lastMapLocation,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<Action>): DispatchProps {
  return {
    actions: bindActionCreators(
      {
        toast,
        viewingBoundsDidChange,
        patchArea,
        createArea,
        deleteArea,
        setLastMapLocation,
      },
      dispatch
    ),
  };
}

export const MarketMapContainer = connect<StateProps, DispatchProps, any, RootState>(mapStateToProps, mapDispatchToProps)(MarketMap);
